// import React, { useEffect, useState } from "react";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import axios from "axios";
// import { Table, Sidenavbar, Dash_radialmenu } from "../../components";
// import { radmenu, subjects, subject_current } from "../../constants/dashboard";
// import "./Dashboard.css";
// import { Progressbar, Underline } from "../../widgets";
// import { sidenav } from "../../constants/dashboard";
// import { Alertmessage } from "../../widgets";
// import Loader from '../../containers/Loader/Loader';
// import generateCustomImage from "../../Functions/generateCustomImage";
// import { IoShareSocial } from "react-icons/io5";

// const Dash_results = () => {
// const [sem_opt_flag, setSem_opt_flag] = useState(false);
// const [results, setResults] = useState([]);
// const [Cgpa, setCpga] = useState(0);
//  const [Gpa, setGpa] = useState(0);
//    const [sem_list, setSem_list] = useState([]);
//    const [sem, setSem] = useState("");
//   const [res_reg_no, setRes_reg_no] = useState("");
//   const [res_stud_data, setRes_stud_data] = useState({});
//  const [res_dept, setRes_dept] = useState("");
//  const navigate = useNavigate();
//  const location = useLocation();
//  const [alertMessage, setAlertMessage] = useState("");
//  const [disableMarksheet, setDisableMarksheet] = useState(false);
//   const [loading, setLoading] = useState(false);
// const showCgpaGpa =
// Number(Gpa) > 0 && Number(Cgpa) > 0;
//    useEffect(() => {
//    document.title = "ACCET-Student Results";
//  }, []);

//  useEffect(() => {
//  setLoading(true); // start loader
//  axios
//       .post("/backend/respublish")
//       .then((res) => {
//         if (res.data.Status === "Success") {
//           const result_dept = res.data.dept.toUpperCase();
//           const res_pub = res.data.results;
//           const dept_sub = result_dept + "_subs";
//           // console.log(subjects["cse_subs"]);
//           // console.log(subjects[dept_sub]["19NM039"]);

//           // console.log(res_pub);

//           res_pub.map((item) => {
//             // console.log(item);

//             // item.subjectname = subjects[dept_sub][item.subcode].subname;
//             item.subjectname = subject_current[item.subcode].subname;
//             return item; // Don't forget to return the modified item
//           });
//           setSem(res_pub[0].current_sem);
//           setResults(res_pub);
//           setRes_dept(result_dept);
//           setRes_reg_no(res.data.regno);
//           setRes_stud_data(res.data.stud_data);
//           get_sem_list(res.data.regno, result_dept);
//           setCpga(res.data.cgpa);
//           setGpa(res.data.gpa);
//         } else {
//           navigate("/login-page");
//         }
//       })
//       .catch((err) => {
//         //console.log(err);
//         setAlertMessage("Your results have not yet been published.");
//       })
//       .finally(() => {
//         setLoading(false); // stops loader no matter success or failure
//       });

//     // console.log(sem);
//   }, [navigate]);

//   const fetch_all_results = async (regno, dept, sem) => {
//     setLoading(true); // start loader
//     console.log(sem);
//     try {
//       setSem(sem);
//       setSem_opt_flag(false);
//       const all_res = await axios.post("/backend/resresult", {
//         regno: regno,
//         dept: dept,
//         sem: sem,
//       });
//       all_res.data.results.map((item) => {
//         // item.subjectname = subjects[dept_sub][item.subcode].subname;
//         // Currently subject names are taken from the subject_current in the dashboard.js, 
//         // but before the subname is taken with the reference of department wise like CSE_subs
//         item.subjectname = subject_current[item.subcode].subname;
//         return item;
//       });
//       setResults(all_res.data.results);
//       setCpga(all_res.data.cgpa);
//       setGpa(all_res.data.gpa);
//       // console.log(res_reg_no,results)
//     } catch (error) {
//       console.error(error);
//     }
//     finally {
//       setLoading(false); // stops loader no matter success or failure
//     }
//   };

//   const get_sem_list = async (regno, dept) => {
//     console.log("Fetching semester list for:", regno, dept);
//     try {
//       const sems = await axios.post("/backend/getsemlist", {
//         regno: regno,
//         dept: dept,
//       });
//       let list = [];
//       sems.data.map((item) => list.push(item.current_sem));
//       list.sort((a, b) => b - a);
//       console.log(list);
//       setSem_list(list);
//     } catch (error) {
//       console.error(error);
//     }
//     // console.log(sems.data)
//   };

//   const download_marksheet = async () => {
//     try {
//       setDisableMarksheet(true);
//       var coolbutton = document.getElementById("coolbutton");
//       var inprogress = false;
//       coolbutton.onclick = function () {
//         if (inprogress) {
//           return false;
//         }
//         inprogress = true;
//         coolbutton.classList.add("coolass_button_first");
//         setTimeout(function () {
//           coolbutton.classList.add("coolass_button_bridge1");
//         }, 500);
//         setTimeout(function () {
//           coolbutton.classList.add("coolass_button_second");
//         }, 600);
//         setTimeout(function () {
//           coolbutton.classList.add("coolass_button_third");
//         }, 700);
//         setTimeout(function () {
//           coolbutton.classList.add("coolass_button_final");
//         }, 1800);
//         setTimeout(function () {
//           coolbutton.classList.remove("coolass_button_final");
//           coolbutton.classList.remove("coolass_button_third");
//           coolbutton.classList.remove("coolass_button_second");
//           coolbutton.classList.remove("coolass_button_bridge1");
//           coolbutton.classList.remove("coolass_button_first");
//           inprogress = false;
//         }, 3200);
//       };

//       const marksheet = await axios.post(
//         "/backend/download_marksheet",
//         {
//           regno: btoa(res_reg_no), // Base64 encode (simple encryption)
//           sem: sem,
//           dept: res_dept,
//           // results: results,
//         },
//         {
//           responseType: "blob", // Important to handle binary data (PDF)
//         }
//       );

//       const url = window.URL.createObjectURL(new Blob([marksheet.data]));

//       // Create a link element and trigger download
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = `${res_reg_no}_Sem${sem}.pdf`; // Specify the filename
//       document.body.appendChild(a);
//       a.click();

//       // Clean up the temporary URL
//       window.URL.revokeObjectURL(url);
//       // console.log(marksheet)
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setDisableMarksheet(false);
//       // setAlertMessage("Your marksheet is downloaded successfully.");
//     }
//   };

//   const column = [
//     // {field:'sno',header:"Sno"},
//     // {field:'sem',header:"sem"},
//     { field: "subcode", header: "subject code" },
//     { field: "subjectname", header: "Subject Name" },
//     { field: "grade", header: "Grade" },
//     { field: "result", header: "Result" },
//   ];
//   const handleAlertMessage = () => {
//     localStorage.removeItem("updateDetailsRequired");
//     navigate("/dashboard");
//   };
//   return (
//     <div>
//       <div className="dashboar-container">
//         {loading && <Loader />}
//         <div className="dash_complete_div">
//           <Sidenavbar links={sidenav} dash_state={1} />
//           <Dash_radialmenu menu_links={radmenu} />
//           <div className="profile-sec">
//             <div className="dash-result">
//               <div>
//                 <div className="dash-result-head">
//   <Underline heading={"Result"} />

//   <div className="dash-personal">
//     <div className="dash-res1">
//       <p className="dash-personal1">
//         <div className="dash-head">Name:</div>
//         {res_stud_data.studentname}
//       </p>

//       <p className="dash-personal1">
//         <div className="dash-head">Register number:</div>
//         {res_reg_no}
//       </p>
//     </div>

//     <div className="dash-res2">
//       <p className="dash-personal2">
//         <div className="dash-head">Batch:</div>
//         {res_stud_data.batch}
//       </p>

//       <p className="dash-personal2">
//         <div className="dash-head">Department:</div>
//         {res_dept}
//       </p>
//     </div>

//     {showCgpaGpa && (
//       <>
//         <div className="dash-res3">
//           <p className="dash-personal3">
//             <div className="dash-head">GPA:</div>
//             {Gpa}
//           </p>
//         </div>

//         <div className="dash-res4">
//           <p className="dash-personal3">
//             <div className="dash-head">CGPA:</div>
//             {Cgpa}
//           </p>
//         </div>
//       </>
//     )}
//   </div>
// </div>

//                 <div className="dash-result-table">
//                   <div className="dash-table-header">
//                      <div className="sem_options_holder" >

//                       <div className="sem_input_holder" onClick={() => setSem_opt_flag(prev => !prev)}>
//                         <div className="sem_input">Sem {sem}</div>
//                         <div className=" fa fa-chevron-circle-down"></div>
//                       </div>

//                       <div className="sem_container">
//                         <div className="sem_options">
//                           {sem_opt_flag &&
//                             sem_list.map((item) => (
//                               <div
//                                 className="sem_dropdown"
//                                 onClick={() => {
//                                   fetch_all_results(res_reg_no, res_dept, item);
//                                   setSem_opt_flag(false);
//                                 }}
//                               >
//                                 Sem {item}
//                               </div>

//                             ))}
//                         </div>
//                       </div>

//                     </div> 
//                     <div className="dash-result-table-head">Semester {sem}</div>
//                   </div>
//                   <div className="dash_res_table_holder">
//                     <Table data={results} columns={column} />
//                    </div>

//                   <div className="marksheet-container">
//   <div className="cool_holder">
//     {showCgpaGpa && (
//       <button
//         onClick={download_marksheet}
//         className="coolass_button"
//         id="coolbutton"
//         disabled={disableMarksheet}
//       ></button>
//     )}
//   </div>

//   <div className="share-container">
//     <button
//       className="share_button"
//       onClick={() =>
//         generateCustomImage(
//           results,
//           res_stud_data,
//           res_reg_no,
//           res_dept,
//           Gpa,
//           Cgpa
//         )
//       }
//     >
//       <IoShareSocial size={24} className="share_icon" />
//     </button>
//   </div>
// </div>
//                   <div className="dash-tbd">
//                     <p className="dash-note">Note : </p>
//                    <p> TBD - To be displayed</p>
//                  </div>
//                  <div className="logout_button logout-btn">
//                    <a className="log_link" href="/logout">
//                      Logout
//                    </a>
//                  </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//      </div>
//        <Alertmessage message={alertMessage} onClose={handleAlertMessage} />
//      </div>
     
//    );
//  };
// export default Dash_results;
 import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useQuery, useMutation } from "@tanstack/react-query";

import { Table, Sidenavbar, Dash_radialmenu } from "../../components";
import { radmenu, sidenav, subject_current } from "../../constants/dashboard";
import { Progressbar, Underline, Alertmessage } from "../../widgets";
import Loader from "../../containers/Loader/Loader";
import generateCustomImage from "../../Functions/generateCustomImage";
import { IoShareSocial } from "react-icons/io5";

import "./Dashboard.css";






const useResults = () =>
  useQuery({
    queryKey: ["results"],
    queryFn: async () => {
      const res = await axios.post("/backend/respublish");

      

       if (!res.data.results || res.data.results.length === 0) {
         throw new Error("Your results have not yet been published.");
       }

      const dept = res.data.dept.toUpperCase();

      const results = res.data.results.map((item) => {
        const subject = subject_current[item.subcode];

        if (!subject) {
          console.error(`Subject not found for subcode: ${item.subcode}`);
          throw new Error("Your results have not yet been published.");
        }

        return {
          ...item,
          subjectname: subject.subname,
        };
      });

      return {
        results,
        sem: results[0]?.current_sem,
        dept,
        regno: res.data.regno,
        stud: res.data.stud_data,
        cgpa: res.data.cgpa,
        gpa: res.data.gpa,
      };
    },
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 10,
  });
const useSemesterResults = (regno, dept, sem) =>
  useQuery({
    queryKey: ["semesterResults", regno, dept, sem],
    queryFn: async () => {
      const res = await axios.post("/backend/resresult", {
        regno,
        dept,
        sem,
      });
      

       if (!res.data.results || res.data.results.length === 0) {
         throw new Error("Your results have not yet been published.");
       }

      const results = res.data.results.map((item) => {
        const subject = subject_current[item.subcode];

        if (!subject) {
          throw new Error("Your results have not yet been published.");
        }

        return {
          ...item,
          subjectname: subject.subname,
        };
      });

      return {
        ...res.data,
        results,
      };
    },
    enabled: !!sem && !!regno && !!dept,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 10,
  });



const useSemList = (regno, dept) =>
  useQuery({
    queryKey: ["semList", regno, dept],
    queryFn: async () => {
      const res = await axios.post("/backend/getsemlist", {
        regno,
        dept,
      });
      

      return res.data
        .map((item) => item.current_sem)
        .sort((a, b) => b - a);
    },
    enabled: !!regno && !!dept,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 10,
  });


const useDownloadMarksheet = (regno, sem, dept) =>
  useMutation({
    mutationFn: async () => {
    
      const res = await axios.post(
        "/backend/download_marksheet",
        {
          regno: btoa(regno),
          sem,
          dept,
        },
        { responseType: "blob" }
      );
      return res.data;
    },
    onSuccess: (blob) => {
      const url = window.URL.createObjectURL(new Blob([blob]));
      const a = document.createElement("a");
      a.href = url;
      a.download = `${regno}_Sem${sem}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    
  });


const Dash_results = () => {
  const navigate = useNavigate();
  const [sem, setSem] = useState(null);
  const [sem_opt_flag, setSem_opt_flag] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const { data, isLoading, isError: isResultsError } = useResults();

 
  const regno = data?.regno;
  const dept = data?.dept;

  const { data: sem_list = [], isError: isSemListError } = useSemList(regno, dept);
  const { data: semData, isFetching,isError: isSemesterResultsError } = useSemesterResults(
    regno,
    dept,
    sem
  );
  const isSemSelected = sem != null;
  const currentSem = isSemSelected ? sem : data?.sem;
  const currentGpa = sem !== null ? semData?.gpa : data?.gpa;
  const currentCgpa = sem !== null ? semData?.cgpa : data?.cgpa;

  const downloadMutation = useDownloadMarksheet(
    regno,
    currentSem,
    dept
  );
  useEffect(() => {
  if (downloadMutation.isError) {
    setAlertMessage("Unable to download marksheet.");
  }
}, [downloadMutation.isError]);

  const results = isSemSelected
    ? semData?.results
    : data?.results;

  useEffect(() => {
    document.title = "ACCET-Student Results";
  }, []);

  useEffect(() => {
  if (isResultsError || isSemesterResultsError||isSemListError) {
    setAlertMessage("Your results have not yet been published.");

    const timer = setTimeout(() => {
      navigate("/login-page");
    }, 2000); 

    return () => clearTimeout(timer);
  }
}, [isResultsError, isSemesterResultsError, isSemListError, navigate]);

  const column = [
    { field: "subcode", header: "subject code" },
    { field: "subjectname", header: "Subject Name" },
    { field: "grade", header: "Grade" },
    { field: "result", header: "Result" },
  ];

  const handleAlertMessage = () => {
   navigate("/login-page");
  };

  const handleDownload = () => {
    const coolbutton = document.getElementById("coolbutton");
    if (!coolbutton) return;
    coolbutton.classList.remove(
      "coolass_button_first",
      "coolass_button_bridge1",
      "coolass_button_second",
      "coolass_button_third",
      "coolass_button_final"
    );
    coolbutton.classList.add("coolass_button_first");

    setTimeout(() => {
      coolbutton.classList.add("coolass_button_bridge1");
    }, 500);

    setTimeout(() => {
      coolbutton.classList.add("coolass_button_second");
    }, 600);

    setTimeout(() => {
      coolbutton.classList.add("coolass_button_third");
    }, 700);

    setTimeout(() => {
      coolbutton.classList.add("coolass_button_final");
    }, 1800);
    downloadMutation.mutate(undefined, {
      onSettled: () => {
        setTimeout(() => {
          coolbutton.classList.remove(
            "coolass_button_first",
            "coolass_button_bridge1",
            "coolass_button_second",
            "coolass_button_third",
            "coolass_button_final"
          );
          coolbutton.blur();
        }, 1400);
      },
    });
  };
  const showCgpaGpa =
  Number(currentGpa) > 0 && Number(currentCgpa) > 0;
  return (
    <div>
      <div className="dashboar-container">
        {(isLoading || isFetching) && <Loader />}

        <div className="dash_complete_div">
          <Sidenavbar links={sidenav} dash_state={1} />
          <Dash_radialmenu menu_links={radmenu} />

          <div className="profile-sec">
            <div className="dash-result">
              <div>
                <div className="dash-result-head">
                  <Underline heading={"Result"} />

                  <div className="dash-personal">
                    <div className="dash-res1">
                      <p className="dash-personal1">
                        <div className="dash-head">Name:</div>{""}
                        {data?.stud?.studentname}
                      </p>
                      <p className="dash-personal1">
                        <div className="dash-head">
                          Register number:
                        </div>
                        {data?.regno}
                      </p>
                    </div>

                    <div className="dash-res2">
                      <p className="dash-personal2">
                        <div className="dash-head">Batch:</div>
                        {data?.stud?.batch}
                      </p>
                      <p className="dash-personal2">
                        <div className="dash-head">Department:</div>
                        {data?.dept}
                      </p>
                       </div>
                      {showCgpaGpa && (
                        <>
                   
                    <div className="dash-res3">
                      <p className="dash-personal3">
                        <div className="dash-head">GPA:</div>
                        {currentGpa}
                      </p>
                    </div>
                    <div className="dash-res4">
                      <p className="dash-personal3">
                        <div className="dash-head">CGPA:</div>
                        {currentCgpa}
                      </p>
                    </div>
                    </>
                    )}
                  </div>
                </div>



                <div className="dash-result-table">
                  <div className="dash-table-header">

                    <div className="sem_options_holder">

                      <div className="sem_input_holder" onClick={() => setSem_opt_flag((prev) => !prev)}>
                        <div className="sem_input">Sem {currentSem}</div>
                        <div className="fa fa-chevron-circle-down"></div>
                      </div>

                      <div className="sem_container">
                        <div
                          className="sem_options">
                          {sem_opt_flag &&
                            sem_list.map((item) => (
                              <div
                                key={item}
                                className="sem_dropdown"
                                onClick={() => {
                                  setSem(item);
                                  setSem_opt_flag(false);// close the dropdown after selecting a semester
                                }}
                              >
                                Sem {item}
                              </div>
                            ))}
                        </div>
                      </div>

                    </div>

                    <div className="dash-result-table-head">
                      Semester {currentSem}
                    </div>

                  </div>

                  <div className="dash_res_table_holder">
                    <Table data={results || []} columns={column} />

                  </div>



                  <div className="marksheet-container">
                    <div className="cool_holder">
                      {showCgpaGpa && <button
                        onClick={handleDownload}
                        className="coolass_button"
                        id="coolbutton"
                        disabled={downloadMutation.isPending}
                        aria-label="Download Marksheet"
                      ></button>}
                    </div>

                    <div className="share-container">
                      <button
                        className="share_button"
                        onClick={() => {
                          generateCustomImage(
                            results,
                            data?.stud,
                            data?.regno,
                            data?.dept,
                            currentGpa,
                            currentCgpa
                            

                          );
                        }
                        }
                      >
                        <IoShareSocial
                          size={24}
                          className="share_icon" />
                      </button>
                    </div>
                  </div>

                  <div className="dash-tbd">
                    <p className="dash-note">Note :</p>
                    <p>TBD - To be displayed</p>
                  </div>

                  <div className="logout_button logout-btn">
                    <a className="log_link" href="/logout">
                      Logout
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <Alertmessage
        message={alertMessage}
        onClose={handleAlertMessage}
      />
    </div>

  );
};

export default Dash_results;